import { clientInstance } from "../config/config"

export const getMyChildrenAPI = () =>
  clientInstance.get("/child/")

export const createInvitationAPI = (data) =>
  clientInstance.post("/child/invitation", data)

export const createChildWithUsernameAPI = (data) =>
  clientInstance.post("/child/create-username", data)

export const updateChildAPI = (studentId, data) =>
  clientInstance.patch(`/child/${studentId}`, data)

export const freezeChildAPI = (studentId) =>
  clientInstance.put(`/child/${studentId}/freeze`)

export const deleteChildAPI = (studentId) =>
  clientInstance.delete(`/child/${studentId}`)

export const resendInvitationAPI = (invitationId) =>
  clientInstance.post(`/child/invitation/${invitationId}/resend`)

export const getChildDetailsAPI = (studentId) =>
  clientInstance.get(`/child/${studentId}/details`)
